import { useSyncExternalStore } from 'react';
import { getRedesignAccount, subscribeToRedesignAccount } from './redesignAccountStore';

function useRedesignAccount() {
    return useSyncExternalStore(subscribeToRedesignAccount, getRedesignAccount);
}

export default useRedesignAccount;
